<template>
  <div class="container-workflowEdit">
    <div v-if="!previewMode" class="pageHeader">
      <i class="el-icon-back" @click="gotoWorkflowList"></i>
      <div class="workflow-info" @click="$refs.editWorkflowInfoDialog.open(requestData)">
        <template v-if="activeMenu == 'process'">
          <div class="name" v-tip>
            <span v-tip style="width: 200px">{{ requestData.name || "未命名工作流" }}</span>
          </div>
          <div class="desc" v-tip>
            <span v-tip style="width: 200px">{{ requestData.desc || "添加流程说明..." }}</span>
          </div>
        </template>
      </div>
      <div class="workflow-menu">
        <div
          class="menu-item"
          :class="{ active: activeMenu == 'process' }"
          @click="switchMenu('process')"
        >
          流程
        </div>
        <div
          class="menu-item"
          :class="{ active: activeMenu == 'history' }"
          @click="switchMenu('history')"
        >
          历史
        </div>
      </div>
      <div class="workflow-operate">
        <template v-if="activeMenu == 'process'">
          <el-tooltip
            v-if="requestData.canRollback"
            effect="dark"
            content="回滚至当前发布的流程"
            placement="bottom"
          >
            <el-button type="warning" plain @click="rollbackWorkflow">
              回滚流程
            </el-button>
          </el-tooltip>
          <el-button type="primary" @click="deployWorkflow">发布流程</el-button>
        </template>
      </div>
    </div>

    <div v-ps ref="scrollWrapper" class="workflow-scroll" :class="{ 'full-page': previewMode }">
      <!--      <span v-if="previewMode" class="icon-close" @click="closePage">-->
      <!--        <i class="el-icon-close"></i>-->
      <!--      </span>-->
      <div
        v-if="activeMenu == 'process'"
        class="workflowEdit"
        v-loading="requestLoading"
        element-loading-background="#f5f5f5"
      >
        <div v-for="(item, index) in processStructure" :key="index">
          <WorkBranchItem v-if="item.type == 'Gateway'" :branchInfo="item"></WorkBranchItem>
          <WorkflowItem v-else :workFlow="item" :controlTypeMap="controlTypeMap"></WorkflowItem>
        </div>
        <div v-if="!requestLoading" class="flexColumn">
          <section class="workflowEndBox">
            <img src="@/assets/images/flowEnd.png" class="workflowEnd" />
            <div class="endText">流程结束</div>
          </section>
        </div>
        <SettingWorkflow
          @deleteConditionMap="deleteConditionMap"
          ref="settingWorkflow"
          :drawerVisible.sync="drawerVisible"
          :workFlowId="requestData.id"
          :workFlowData="requestData"
          :workFlowProcess="selectedWorkFlow"
          :triggerSheetId="trigger.sheetId"
          :controlTypeMap="controlTypeMap"
        ></SettingWorkflow>
        <setting-gateway-dialog
          ref="settingGatewayDialog"
          :work-flow-id="requestData.id"
        ></setting-gateway-dialog>
        <InsertFlowNode
          :drawerVisible.sync="insertNodeVisible"
          :workflow="requestData"
          @insertFlowNode="insertFlowNode"
          :pre-node="preNode"
          :branch-index="branchIndex"
        ></InsertFlowNode>
      </div>
      <WorkFlowHistory
        v-else-if="activeMenu == 'history'"
        :workflow-id="$route.query.id"
      ></WorkFlowHistory>
    </div>
    <edit-workflow-info-dialog
      ref="editWorkflowInfoDialog"
      @submit="editWorkflowInfo"
    ></edit-workflow-info-dialog>
  </div>
</template>

<script>
import * as workflowApi from "@/api/workflow/workflow"
import {
  WorkflowItem,
  WorkBranchItem,
  SettingWorkflow,
  InsertFlowNode,
  WorkFlowHistory
} from "./components"
import SettingGatewayDialog from "@/views/Backend/AdminEdit/Workflow/components/SettingGatewayDialog"
import {
  transferProcessStructure,
  updateFlowNode,
  insertFlowNode,
  deleteFlowNode
} from "@/utils/workFlow"
import { EventBus } from "./eventBus.js"
import { getAllDefaultControls } from "@/api/sheet/sheet"
import EditWorkflowInfoDialog from "@/views/Backend/AdminEdit/Workflow/components/EditWorkflowInfoDialog"

export default {
  name: "workflowEdit",
  components: {
    EditWorkflowInfoDialog,
    WorkflowItem,
    WorkBranchItem,
    SettingWorkflow,
    SettingGatewayDialog,
    InsertFlowNode,
    WorkFlowHistory
  },
  data() {
    return {
      drawerVisible: false,
      selectedWorkFlow: {},
      branchIndex: null,
      processStructure: [],
      requestData: {},
      requestLoading: true,
      insertNodeVisible: false,
      preNode: null,
      previewMode: this.$route.meta?.preview ?? false, // 预览模式
      workflowType: {
        data: "app",
        id: "" // 如果data是app,则为appId,如果是project则为projectId
      },
      trigger: {},
      controlTypeMap: {},
      triggerType: null,
      page: null
    }
  },
  provide() {
    return {
      workflowType: this.workflowType,
      previewMode: this.previewMode
    }
  },
  computed: {
    activeMenu() {
      if (String(this.$route.query.history) == "true") return "history"
      else return "process"
    }
  },
  created() {
    this.triggerType = this.$route.params?.group
    this.page = this.$route.params?.page
    if (String(this.$route.query.history) != "true") {
      this.refreshWorkflow()
    }
    getAllDefaultControls().then(res => (this.controlTypeMap = this._.keyBy(res, "_type")))
  },
  mounted() {
    if (!this.previewMode) this.initEvent()
  },
  methods: {
    initEvent() {
      // 监听事件：打开节点设置页
      EventBus.$on("openSetting", param => {
        this.selectedWorkFlow = param.workFlow
        EventBus.$data.activeWorkFlow = param.workFlow
        if (this.selectedWorkFlow.type == "Gateway") {
          this.$refs.settingGatewayDialog.open(param)
          this.branchIndex = param.branchIndex
        } else this.drawerVisible = true
      })
      // 监听事件：更新节点
      EventBus.$on("updateFlowNode", param => {
        if (!param.refreshFlowConnectedData) {
          this.drawerVisible = false
          this.requestLoading = true
        }
        this.$set(param.nodeInfo.extra, "isGray", false)
        this.requestData = updateFlowNode(this.requestData, param.nodeInfo)
        this.updateWorkflow().then(() => {
          // 新建的更新工作表节点需要刷新 flowConnectedData
          if (param.refreshFlowConnectedData) this.$refs.settingWorkflow.getFlowConnectedData()
        })
      })
      // 监听事件：打开插入节点页
      EventBus.$on("openInsertNode", param => {
        this.branchIndex = param.branchIndex
        this.preNode = param.workFlow
        this.insertNodeVisible = true
      })
      // 监听事件：删除节点
      EventBus.$on("deleteNode", param => {
        this.branchIndex = param.branchIndex
        let confirmMsg
        if (param.workFlow.type == "Gateway") {
          confirmMsg =
            param.workFlow.nexts.length <= 2
              ? "此操作将删除分支节点及其范围内的所有节点, 是否继续?"
              : "此操作将删除当前分支内的所有节点, 是否继续?"
        } else confirmMsg = "此操作将删除该节点, 是否继续?"
        this.$confirm(confirmMsg, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          this.requestLoading = true
          this.requestData = deleteFlowNode(this.requestData, param.workFlow, param.branchIndex)
          this.updateWorkflow()
          this.processStructure = transferProcessStructure(this.requestData.dmProcess.items)
          this.addWorkFlowStart()
        })
      })
      // 组件销毁时，移除监听事件
      this.$on("hook:destroyed", () => {
        EventBus.$off("openSetting")
        EventBus.$off("updateFlowNode")
        EventBus.$off("openInsertNode")
        EventBus.$off("deleteNode")
      })
    },
    // 获取工作流信息
    refreshWorkflow() {
      this.requestLoading = true
      return workflowApi.getWorkflow(this.$route.query.id).then(workflow => {
        this.initWorkflow(workflow)
        if (["未命名工作流", "自定义按钮"].includes(workflow.name))
          this.$refs.editWorkflowInfoDialog.open(workflow)
        this.hideRequestLoading()
        this.$nextTick(() => {
          // 自动滚动到水平中间
          let scrollWrapper = this.$refs.scrollWrapper
          scrollWrapper.scrollLeft = (scrollWrapper.scrollWidth - scrollWrapper.clientWidth) / 2
        })
      })
    },
    initWorkflow(workflow) {
      this.requestData = workflow
      Object.assign(this.workflowType, {
        id: workflow.appId,
        data: workflow.type === "task" ? "project" : "app"
      })
      this.trigger = workflow.trigger
      this.processStructure = transferProcessStructure(workflow.dmProcess.items)
      this.addWorkFlowStart()
    },
    gotoWorkflowList() {
      if (window.history.length > 2) {
        this.$router.back()
      } else if (this.requestData.type === "task") {
        this.$router.push({
          name: "admin-project-task-approval",
          params: { projectId: this.requestData.appId }
        })
      } else {
        this.$router.push({
          name: "admin-workflow",
          params: { appId: this.requestData.appId },
          query: { group: this.triggerType || "START_TYPE_DATA", page: this.page || "1" }
        })
      }
    },
    // 添加工作流开始节点
    addWorkFlowStart() {
      this.processStructure.unshift({
        type: "workFlowStart",
        id: this.requestData.id,
        name: this.requestData.name,
        desc: this.requestData.desc,
        trigger: this.requestData.trigger,
        nexts: this.processStructure[0]?.id ? [this.processStructure[0].id] : []
      })
    },
    // 插入新节点
    insertFlowNode(insertNodeType, moveFlag) {
      this.requestLoading = true
      this.insertNodeVisible = false
      this.requestData = insertFlowNode({
        requestData: this.requestData,
        preNode: this.preNode,
        insertNodeType: insertNodeType.type,
        branchIndex: this.branchIndex,
        moveFlag,
        dataType: insertNodeType.dataType || ""
      })
      this.processStructure = transferProcessStructure(this.requestData.dmProcess.items)
      this.updateWorkflow()
      this.addWorkFlowStart()
    },
    // 关闭 loading
    hideRequestLoading() {
      setTimeout(() => {
        this.requestLoading = false
      }, 200)
    },
    // 更新工作流
    updateWorkflow() {
      return workflowApi.updateWorkflow(this.requestData).then(workflow => {
        this.initWorkflow(workflow)
        this.hideRequestLoading()
        this.$message.success("工作流更新成功！")
      })
    },
    // 修改工作流的名称和描述
    editWorkflowInfo({ name, desc, parallel, userToNotify }) {
      this.requestLoading = true
      this.requestData.name = this.processStructure[0].name = name
      this.requestData.desc = this.processStructure[0].desc = desc
      this.requestData.parallel = this.processStructure[0].parallel = parallel
      this.requestData.userToNotify = this.processStructure[0].userToNotify = userToNotify
      this.updateWorkflow()
    },
    // 发布工作流
    deployWorkflow() {
      this.requestLoading = true
      workflowApi
        .deployWorkflow(this.requestData.id)
        .then(() => {
          this.refreshWorkflow()
          this.$message.success("工作流发布成功！")
        })
        .finally(() => {
          this.hideRequestLoading()
        })
    },
    // 回滚工作流
    rollbackWorkflow() {
      this.requestLoading = true
      workflowApi.rollbackWorkflow(this.requestData.id).then(workflow => {
        this.initWorkflow(workflow)
        this.hideRequestLoading()
        this.$message.success("回滚成功：工作流已回滚至当前发布的流程")
      })
    },
    // 切换选中菜单
    switchMenu(menuItem) {
      if (menuItem != this.activeMenu) {
        this.$router.replace({
          name: "admin-edit-workflow",
          query: { id: this.$route.query.id, history: menuItem == "history" }
        })
        if (menuItem == "process") {
          this.refreshWorkflow()
        }
      }
    },
    closePage() {
      window.pener = null
      window.open("about:blank", "_self")
      window.close()
    },
    deleteConditionMap(msg) {
      // 删除校验节点中已被删除的rules数据
      delete this.selectedWorkFlow.extra.conditionMap.ruleMap[msg]
    }
  }
}
</script>

<style lang="scss">
.container-workflowEdit {
  background-color: #f5f5f5;
  .pageHeader {
    position: absolute;
    top: 0;
    display: flex;
    justify-content: space-between;
    width: 100%;
    box-sizing: border-box;
    padding: 0 20px;
    height: 55px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
    align-items: center;
    background: #fff;
    z-index: 10;

    .el-icon-back {
      margin-right: 15px;
      font-size: 20px;
      font-weight: bold;
      cursor: pointer;
      &:hover {
        color: #1e88e5;
      }
    }
    .workflow-info {
      flex: 1 1;
      cursor: pointer;
      .name {
        font-size: 17px;
      }
      .desc {
        font-size: 12px;
        color: #9e9e9e;
      }
    }
    .workflow-menu {
      margin: auto;
      line-height: 51px;
      display: inline-flex;
      margin-right: 48px;
      .menu-item {
        margin: 0 20px;
        box-sizing: border-box;
        cursor: pointer;
        border-bottom-width: 4px;
        border-bottom-style: solid;
        transition: all 0.3s ease-out;
        border-bottom-color: #fff;
        &.active {
          border-bottom-color: #1e88e5;
        }
      }
      // justify-content: center;
      // margin-right: 34px;
    }
    .workflow-operate {
      flex: 1 1;
      display: flex;
      justify-content: flex-end;
    }
  }
  .workflow-scroll {
    position: absolute;
    top: 55px;
    width: 100%;
    height: calc(100vh - 55px);
    overflow: auto;
    &.full-page {
      top: 0;
      min-height: 100vh;
      height: 100vh;
    }
    .icon-close {
      position: fixed;
      top: 8px;
      right: 16px;
      font-size: 32px;
      font-weight: bold;
      z-index: 999;
      &:hover {
        color: $color-main;
      }
      i {
        cursor: pointer;
      }
    }
    .workflowEdit {
      background-color: #f5f5f5;
      display: inline-block;
      min-width: 100%;
      min-height: 100%;
      font-size: 16px;
      padding-top: 24px;
      box-sizing: border-box;
      .flexColumn {
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        .workflowEndBox {
          padding: 0 50px 120px;
          .workflowEnd {
            width: 56px;
            height: 32px;
            margin: 0 auto;
          }
          .endText {
            font-size: 13px;
            color: #9e9e9e;
            margin-top: 10px;
          }
        }
      }
    }
  }
}
</style>
